import { createStore } from 'vuex';
import { request } from '@/utils/apiClient';

export default createStore({
  state: {
    user: null,
  },
  getters: {
    getUser(state) {
      return state.user;
    },
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    clearUser(state) {
      state.user = null;
    },
  },
  actions: {
    async fetchUser({ commit }, userId) {
      const userData = await fetchUserData(userId);
      if (!userData) return;
      commit('setUser', userData);
    },
    async logout({ commit }) {
      try {
        await logout();
      } catch(err) {
        console.error(err)
      } finally {
        commit('clearUser');
      }
    },
  },
});

async function fetchUserData() {
  try {
    let isLogin = await request('api/user/is_login/');
    isLogin = isLogin?.data?.is_logged_in;
    if (!isLogin) return null;
    const resopnse = await request('api/user/profile', 'get');
    return resopnse?.data;
  } catch (err) {
    console.error(err)
    return null;
  }
}

async function logout() {
  try {
    const resopnse = await request('api/user/logout/', 'put')
    return resopnse
  } catch (err) {
    console.error(err)
    return {}
  }
}
